{
  "en": {
    "title": "Minetrack Sweden",
    "metaDescription": "Minetrack Sweden is a live Minecraft server tracker aiming to track player statistics for all major servers in Sweden",
    "statusConnecting": "Connecting...",
    "subtitle": "Tracking {statNetworks} Minecraft servers with {statTotalPlayers} players across Sweden",
    "sortByLabel": "Sort By",
    "graphControlsLabel": "Graph Controls",
    "showAll": "Show All",
    "hideAll": "Hide All",
    "onlyFavorites": "Only Favorites",
    "footerPoweredBy": "Powered by {link} (open-source)",
    "switchLanguageLabel": "Set locale:",
    "languageToggleLabel": "Svenska",
    "serverProposalButton": "Suggest a server",
    "serverProposalTitle": "Suggest a Minecraft server",
    "serverProposalIntro": "Know a Swedish server that should be tracked?",
    "serverProposalName": "Server name",
    "serverProposalAddress": "Server address",
    "serverProposalWebsite": "Website (optional)",
    "serverProposalNotes": "Notes (optional)",
    "serverProposalSubmit": "Send proposal",
    "serverProposalCancel": "Cancel",
    "serverProposalSuccess": "Thanks! Your proposal has been sent.",
    "serverProposalError": "The proposal could not be sent. Please try again later.",
    "captionLoading": "Loading...",
    "captionLostConnection": "Lost connection!",
    "captionDisconnected": "Disconnected due to error.",
    "captionReconnecting": "Reconnecting...",
    "captionReconnectingIn": "Reconnecting in {seconds}s...",
    "playersLabel": "Players",
    "peakLabel": "{duration} Peak",
    "recordLabel": "Record",
    "atDateTime": "At {date} {time}",
    "atTime": "At {time}",
    "failedToPing": "Failed to ping",
    "clickToCopy": "Click to copy {address}",
    "copied": "Copied {address}",
    "couldNotCopy": "Could not copy {address}",
    "playersCount": "{count} Players"
  },
  "sv": {
    "title": "Minetrack Sweden",
    "metaDescription": "Minetrack Sweden är en sida med mål att spåra spelarstatistik för alla större servrar i Sverige",
    "statusConnecting": "Ansluter...",
    "subtitle": "Spårar {statNetworks} Minecraft-servrar med {statTotalPlayers} spelare i Sverige",
    "sortByLabel": "Sortera efter",
    "graphControlsLabel": "Graf- inställningar",
    "showAll": "Visa alla",
    "hideAll": "Dölj alla",
    "onlyFavorites": "Endast favoriter",
    "footerPoweredBy": "Drivs av {link} (öppen källkod)",
    "switchLanguageLabel": "Byt språk:",
    "languageToggleLabel": "English",
    "serverProposalButton": "Föreslå en server",
    "serverProposalTitle": "Föreslå en Minecraft-server",
    "serverProposalIntro": "Känner du till en svensk server som borde spåras?",
    "serverProposalName": "Servernamn",
    "serverProposalAddress": "Serveradress",
    "serverProposalWebsite": "Webbplats (valfritt)",
    "serverProposalNotes": "Övriga uppgifter (valfritt)",
    "serverProposalSubmit": "Skicka förslag",
    "serverProposalCancel": "Avbryt",
    "serverProposalSuccess": "Tack! Ditt förslag har skickats.",
    "serverProposalError": "Förslaget kunde inte skickas. Försök igen senare.",
    "captionLoading": "Laddar...",
    "captionLostConnection": "Anslutningen tappades!",
    "captionDisconnected": "Frånkopplad på grund av ett fel...",
    "captionReconnecting": "Ansluter igen...",
    "captionReconnectingIn": "Ansluter igen om {seconds}s...",
    "playersLabel": "Spelare",
    "peakLabel": "{duration} topp",
    "recordLabel": "Rekord",
    "atDateTime": "Vid {date} {time}",
    "atTime": "Vid {time}",
    "failedToPing": "Pingning misslyckades",
    "clickToCopy": "Klicka för att kopiera {address}",
    "copied": "{address} kopierad",
    "couldNotCopy": "Kunde inte kopiera {address}",
    "playersCount": "{count} spelare"
  }
}
